import { useTranslation } from 'react-i18next'
import messageUtil from 'utils/messageUtil'
import InsightViewOption, { InsightViewOptionStrings } from 'enums/InsightViewOption'

const useViewOptionName = (viewOption: InsightViewOptionStrings) => {
  const { t } = useTranslation()

  switch (viewOption) {
    case InsightViewOption.TERMS:
      return t('term')

    case InsightViewOption.HASHTAGS:
      return t('hashtag_other')

    case InsightViewOption.EMOJIS_GROUP:
      return t('emoji_types')

    case InsightViewOption.EMOJIS_EMOTION:
      return t('emoji_emotions')

    case InsightViewOption.EMOJIS_EMOJI:
      return t('emoji')

    case InsightViewOption.BRANDS:
      return t('brand')

    case InsightViewOption.PEOPLE:
      return t('people')

    case InsightViewOption.ATTRIBUTES:
      return t('attribute')

    case InsightViewOption.EMOTIONS:
      return t('emotion')

    case InsightViewOption.BEHAVIORS:
      return t('behavior')

    case InsightViewOption.THINGS:
      return t('thing')

    case InsightViewOption.PRODUCT_NAME:
      return t('product_name')

    case InsightViewOption.STAR_RATINGS:
      return t('star_rating')

    case InsightViewOption.SURVEY_SCORES:
      return t('survey_score')

    default:
      return t(messageUtil.viewOption(viewOption))
  }
}

export default useViewOptionName
